import { render, staticRenderFns } from "./Fazenda.vue?vue&type=template&id=115ae06a&scoped=true"
import script from "./Fazenda.vue?vue&type=script&lang=js"
export * from "./Fazenda.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=115ae06a&prod&scoped=true&lang=css&external"
import style1 from "./Fazenda.vue?vue&type=style&index=1&id=115ae06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ae06a",
  null
  
)

export default component.exports